import { HTTPResponse, IPaginationRequestQuery, IPaginationResponse } from '@/services/http/http.types.ts'
import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import http, { handleHttpError, handleHttpResponse } from '@/services/http'
import { IUser, IUserAdminRouteHistory, IUserInfo, TCreateUserDTO } from '@/pages/Users/users.types.ts'

// user_id__in - список id пользователей, передавать в виде строки "1,2,3"
const list = (
  params: IPaginationRequestQuery & Partial<{ organizationId: IOrganization['id']; user_id__in: string }>
): Promise<HTTPResponse<IPaginationResponse<IUser>>> => {
  return http.get('/nsi/v1/users', { params }).then(handleHttpResponse).catch(handleHttpError)
}

const getOne = async (id: IUser['id']): Promise<HTTPResponse<IUser>> => {
  return http
    .get('/nsi/v1/users/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const create = async (dto: TCreateUserDTO): Promise<HTTPResponse<IUser>> => {
  return http.post('/nsi/v1/users', dto).then(handleHttpResponse).catch(handleHttpError)
}

const update = async (
  id: IUser['id'],
  updates: Partial<Omit<IUser, 'userInfo'>> & { userInfo: Partial<IUserInfo> }
): Promise<HTTPResponse<IUser>> => {
  return http.patch(`/nsi/v1/users/${id}`, updates).then(handleHttpResponse).catch(handleHttpError)
}

const remove = async (id: IUser['id']): Promise<HTTPResponse<IUser>> => {
  return http.delete(`/nsi/v1/users/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const getUserAvatar = async (id: IUser['id']): Promise<HTTPResponse<Blob>> => {
  return http
    .get(`/nsi/v1/users/${id}/avatar`, { responseType: 'blob' })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const getAdminRoutesHistory = async (
  id: IUser['id'],
  params: IPaginationRequestQuery & { pageToken?: string }
): Promise<HTTPResponse<IPaginationResponse<IUserAdminRouteHistory>>> => {
  return http
    .get(`/nsi/v1/users/${id}/admin/routes-history`, { params })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const usersApi = { list, getOne, create, update, remove, getUserAvatar, getAdminRoutesHistory }
export default usersApi
